module.exports = __webpack_public_path__ + "img/scene2.5d9e747d.webp";